var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"type":"button","size":_vm.size,"variant":_vm.variant},on:{"click":_vm.confirm}},[(!_vm.icon)?_c('span',[_vm._v("Delete")]):_vm._e(),(_vm.icon)?_c('i',{staticClass:"mdi mdi-trash-can"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }